import { useEffect, useMemo, useRef, useState } from "react";
import {
    X, Megaphone, Copy, Link2, SlidersHorizontal, ChevronDown, Globe,
} from "lucide-react";
import { authService } from "../../services/api";
import { useNotification } from "../../components/Notifications/NotificationContext";
import Loading from "../../components/UI/Loading/Loading";

/* ---- Ícones de marca (SVG simple-icons) ---- */
const BRANDS = {
    meta: { c: "#0866FF", d: "M6.915 4.03c-1.968 0-3.683 1.28-4.871 3.113C.704 9.208 0 11.883 0 14.449c0 .706.07 1.369.21 1.973a6.624 6.624 0 0 0 .265.86 5.297 5.297 0 0 0 .371.761c.696 1.159 1.818 1.927 3.593 1.927 1.497 0 2.633-.671 3.965-2.444.76-1.012 1.144-1.626 2.663-4.32l.756-1.339.186-.325c.061.1.121.196.183.3l2.152 3.595c.724 1.21 1.665 2.556 2.47 3.314 1.046.987 1.992 1.22 3.06 1.22 1.075 0 1.876-.354 2.455-.843a3.743 3.743 0 0 0 .81-.973c.542-.939.861-2.127.861-3.745 0-2.72-.681-5.357-2.084-7.45-1.282-1.912-2.957-2.93-4.716-2.93-1.047 0-2.088.467-3.053 1.308-.652.57-1.257 1.29-1.82 2.05-.69-.875-1.335-1.547-1.958-2.056-1.182-.966-2.315-1.303-3.454-1.303zm10.16 2.053c1.147 0 2.188.758 2.992 1.999 1.132 1.748 1.647 4.195 1.647 6.4 0 1.548-.368 2.9-1.839 2.9-.58 0-1.027-.23-1.664-1.004-.496-.601-1.343-1.878-2.832-4.358l-.617-1.028a44.908 44.908 0 0 0-1.255-1.98c.07-.109.141-.224.211-.327 1.12-1.667 2.118-2.602 3.223-2.602zm-10.201.553c1.234 0 2.418.911 3.328 2.31.435.663.898 1.398 1.372 2.185l-1.313 2.302c-.746 1.31-1.319 2.147-1.828 2.803-1.1 1.416-1.83 1.72-2.75 1.72-.769 0-1.398-.377-1.816-1.256-.354-.71-.541-1.65-.541-2.685 0-2.681.674-4.802 1.501-6.116.628-1.001 1.396-1.586 2.365-1.586z" },
    tiktok: { c: "#ffffff", d: "M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" },
    google: { c: "#4285F4", d: "M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z" },
    x: { c: "#ffffff", d: "M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z" },
    instagram: { c: "#E4405F", d: "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" },
    youtube: { c: "#FF0000", d: "M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" },
    whatsapp: { c: "#25D366", d: "M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.149-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.885-9.885 9.885M20.52 3.449C18.24 1.245 15.24 0 12.045 0 5.463 0 .104 5.359.101 11.892c0 2.096.549 4.14 1.595 5.945L0 24l6.335-1.652a11.882 11.882 0 005.71 1.454h.006c6.585 0 11.946-5.359 11.949-11.945a11.821 11.821 0 00-3.495-8.411" },
};

function BrandIcon({ brand, size = 16 }) {
    // Kwai não tem path confiável -> monograma laranja
    if (brand === "kwai") {
        return (
            <span
                style={{ width: size, height: size, fontSize: size * 0.62 }}
                className="inline-flex items-center justify-center rounded bg-[#FF5000] text-white font-bold leading-none"
            >K</span>
        );
    }
    const it = BRANDS[brand];
    if (!it) return <Globe size={size} />;
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill={it.c} aria-hidden="true">
            <path d={it.d} />
        </svg>
    );
}

/* ---- Origens ---- */
const AD_ORIGINS = [
    {
        id: "meta", label: "Meta Ads", brand: "meta", ready: true,
        utm: {
            source: "FB",
            campaign: "{{campaign.name}}|{{campaign.id}}",
            medium: "{{adset.name}}|{{adset.id}}",
            content: "{{ad.name}}|{{ad.id}}",
            term: "{{placement}}",
            id: "{{campaign.id}}",
        },
    },
    {
        id: "tiktok", label: "TikTok Ads", brand: "tiktok", ready: true,
        utm: {
            source: "tiktok",
            campaign: "__CAMPAIGN_NAME__|__CAMPAIGN_ID__",
            medium: "__AID_NAME__|__AID__",
            content: "__CID_NAME__|__CID__",
            term: "__PLACEMENT__",
            id: "__CAMPAIGN_ID__",
        },
    },
    { id: "google", label: "Google Ads", brand: "google", ready: false, utm: {} },
    { id: "kwai", label: "Kwai Ads", brand: "kwai", ready: false, utm: {} },
    { id: "x", label: "X Ads", brand: "x", ready: false, utm: {} },
];

const ORGANIC_ORIGINS = [
    { id: "instagram_bio", label: "Instagram Bio", brand: "instagram", start: "instagram", utm: { source: "instagram", campaign: "bio", medium: "organic", content: "profile", term: "", id: "" } },
    { id: "tiktok_bio", label: "TikTok Bio", brand: "tiktok", start: "tiktok", utm: { source: "tiktok", campaign: "bio", medium: "organic", content: "profile", term: "", id: "" } },
    { id: "twitter_bio", label: "Twitter/X Bio", brand: "x", start: "twitter", utm: { source: "twitter", campaign: "bio", medium: "organic", content: "profile", term: "", id: "" } },
    { id: "youtube_desc", label: "YouTube Descrição", brand: "youtube", start: "youtube", utm: { source: "youtube", campaign: "descricao", medium: "organic", content: "description", term: "", id: "" } },
    { id: "whatsapp_status", label: "WhatsApp Status", brand: "whatsapp", start: "whatsapp", utm: { source: "whatsapp", campaign: "status", medium: "organic", content: "status", term: "", id: "" } },
];

const ALL_ORIGINS = [...AD_ORIGINS, ...ORGANIC_ORIGINS];

const UTM_FIELDS = [
    { key: "source", label: "Origem", utm: "utm_source" },
    { key: "campaign", label: "Campanha", utm: "utm_campaign" },
    { key: "medium", label: "Conjunto ou mídia", utm: "utm_medium" },
    { key: "content", label: "Criativo", utm: "utm_content" },
    { key: "term", label: "Posicionamento", utm: "utm_term" },
    { key: "id", label: "ID da campanha", utm: "utm_id" },
];

function buildParams(p, sx, start) {
    const parts = [];
    if (p.source) parts.push(`utm_source=${p.source}`);
    if (p.campaign) parts.push(`utm_campaign=${p.campaign}`);
    if (p.medium) parts.push(`utm_medium=${p.medium}`);
    if (p.content) parts.push(`utm_content=${p.content}`);
    if (p.term) parts.push(`utm_term=${p.term}`);
    if (p.id) parts.push(`utm_id=${p.id}`);
    if (sx) parts.push(`sx=${sx}`);
    if (start) parts.push(`start_param=${start}`);
    return parts.join("&");
}

/* ---- Dropdown temático (origens orgânicas) ---- */
function OrganicSelect({ value, onSelect }) {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    const selected = ORGANIC_ORIGINS.find((o) => o.id === value);

    useEffect(() => {
        function onDoc(e) {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        }
        document.addEventListener("mousedown", onDoc);
        return () => document.removeEventListener("mousedown", onDoc);
    }, []);

    return (
        <div className="relative" ref={ref}>
            <button
                type="button"
                onClick={() => setOpen((v) => !v)}
                className="w-full flex items-center justify-between gap-2 px-3 py-2.5 rounded-xl bg-white/[0.03] border border-white/[0.08] text-sm text-white outline-none hover:border-white/20 transition"
            >
                <span className="flex items-center gap-2 min-w-0">
                    {selected ? <BrandIcon brand={selected.brand} size={16} /> : null}
                    <span className={`truncate ${selected ? "text-white" : "text-white/50"}`}>
                        {selected ? selected.label : "Outras origens ou modelo personalizado"}
                    </span>
                </span>
                <ChevronDown size={16} className={`text-white/40 flex-shrink-0 transition-transform ${open ? "rotate-180" : ""}`} />
            </button>

            {open && (
                <div className="absolute z-10 mt-1.5 w-full rounded-xl border border-white/[0.1] bg-[#161b22] shadow-[0_16px_40px_rgba(0,0,0,0.5)] overflow-hidden py-1">
                    {ORGANIC_ORIGINS.map((o) => (
                        <button
                            key={o.id}
                            type="button"
                            onClick={() => { onSelect(o.id); setOpen(false); }}
                            className={`w-full flex items-center gap-2.5 px-3 py-2.5 text-sm text-left transition ${value === o.id ? "bg-[rgba(139,92,246,0.18)] text-white" : "text-white/80 hover:bg-white/[0.06]"}`}
                        >
                            <BrandIcon brand={o.brand} size={16} /> {o.label}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}

function CopyRow({ label, hint, value, copyLabel, primary }) {
    const { showSuccess } = useNotification();
    const copy = () => {
        navigator.clipboard.writeText(value);
        showSuccess("Copiado para a área de transferência.");
    };
    return (
        <div className={`rounded-xl border p-3 h-full flex flex-col ${primary ? "border-[rgba(139,92,246,0.35)] bg-[#0d0819]" : "border-white/[0.08] bg-white/[0.02]"}`}>
            <div className="mb-1.5 min-w-0">
                <div className="text-sm font-semibold text-white">{label}</div>
                {hint && <div className="text-[11px] text-white/40">{hint}</div>}
            </div>
            <div className="text-xs text-[#a78bfa] break-all bg-black/30 rounded-lg px-3 py-2 border border-white/[0.05] flex-1">
                {value || "—"}
            </div>
            <button onClick={copy} className={`${primary ? "btn-primary" : "btn-secondary"} mt-2 w-full flex items-center justify-center gap-2 text-sm`}>
                <Copy size={14} /> {copyLabel || `Copiar ${label}`}
            </button>
        </div>
    );
}

export default function CampaignModal({ open, slug, onClose }) {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    const [selectedId, setSelectedId] = useState("meta");
    const [params, setParams] = useState(AD_ORIGINS[0].utm);
    const [advancedOpen, setAdvancedOpen] = useState(false);
    // Domínio do link (undefined = o padrão que o backend escolher).
    const [domain, setDomain] = useState(undefined);

    const origin = useMemo(() => ALL_ORIGINS.find((o) => o.id === selectedId), [selectedId]);
    const isOrganicSelected = ORGANIC_ORIGINS.some((o) => o.id === selectedId);

    // Abriu (ou trocou de redirecionador): volta tudo ao início.
    useEffect(() => {
        if (!open || !slug) return;
        setData(null);
        setLoading(true);
        setDomain(undefined);
        setSelectedId("meta");
        setParams(AD_ORIGINS[0].utm);
        setAdvancedOpen(false);
    }, [open, slug]);

    // Link do domínio escolhido. Trocar o domínio mantém origem e parâmetros.
    useEffect(() => {
        if (!open || !slug) return undefined;
        let mounted = true;
        authService.redirects
            .get_campaign(slug, domain)
            .then((res) => { if (mounted && res.data?.success) setData(res.data.data); })
            .catch(() => { })
            .finally(() => mounted && setLoading(false));
        return () => { mounted = false; };
    }, [open, slug, domain]);

    function selectOrigin(id) {
        const o = ALL_ORIGINS.find((x) => x.id === id);
        setSelectedId(id);
        setParams({ source: "", campaign: "", medium: "", content: "", term: "", id: "", ...(o?.utm || {}) });
    }

    if (!open) return null;

    const sx = data?.sx || "";
    const siteUrl = data?.site_url || "";
    const ready = origin?.ready !== false;
    const paramString = buildParams(params, sx, origin?.start);
    const fullUrl = `${siteUrl}?${paramString}`;

    return (
        <div className="fixed inset-0 z-[99999] flex items-center justify-center p-2 md:p-4">
            <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />
            <div
                className="relative w-full max-w-4xl rounded-2xl border border-white/[0.09] bg-[#10141a] p-4 md:p-6 shadow-[0_24px_64px_rgba(0,0,0,0.55)] text-white"
                style={{ maxHeight: "92vh", overflowY: "auto", colorScheme: "dark" }}
            >
                {/* Header */}
                <div className="flex items-start justify-between mb-6 gap-3">
                    <div className="flex items-center gap-3 min-w-0">
                        <div className="flex-shrink-0 w-10 h-10 rounded-xl bg-[rgba(139,92,246,0.12)] border border-[rgba(139,92,246,0.18)] flex items-center justify-center text-[#a78bfa]">
                            <Megaphone size={20} />
                        </div>
                        <div className="min-w-0">
                            <h2 className="text-lg font-semibold">Prepare o link da campanha</h2>
                            <p className="text-sm text-white/50">
                                Escolha a origem e a Spectrum monta as macros corretas.
                            </p>
                        </div>
                    </div>
                    <button onClick={onClose} className="action-btn flex-shrink-0" aria-label="Fechar">
                        <X size={18} />
                    </button>
                </div>

                {loading || !data ? (
                    <Loading text="Montando o link..." />
                ) : (
                    <>
                        {/* Link base */}
                        <div className="rounded-xl border border-white/[0.08] bg-white/[0.02] p-4 mb-6 flex items-center gap-3">
                            <Link2 size={18} className="text-[#a78bfa] flex-shrink-0" />
                            <div className="min-w-0">
                                <div className="text-xs uppercase tracking-wide text-white/40">Link base</div>
                                <div className="text-sm text-white truncate">{siteUrl}</div>
                                <div className="text-[11px] text-white/40">
                                    Domínio: {data.domain}
                                    {sx && <> · Cloaker <code className="text-[#fbbf24]">sx={sx}</code></>}
                                </div>
                            </div>
                        </div>

                        {/* Domínio do link: só aparece se houver mais de um */}
                        {(data.domains || []).length > 1 && (
                            <div className="mb-6 -mt-3">
                                <div id="campaign-domain-label" className="text-xs uppercase tracking-wide text-white/40 mb-2">
                                    Domínio do link
                                </div>
                                <div role="radiogroup" aria-labelledby="campaign-domain-label" className="flex flex-wrap gap-2">
                                    {data.domains.map((d) => {
                                        const active = data.domain === d.hostname;
                                        return (
                                            <button
                                                key={d.hostname}
                                                type="button"
                                                role="radio"
                                                aria-checked={active}
                                                onClick={() => !active && setDomain(d.hostname)}
                                                className={`inline-flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition ${active
                                                    ? "bg-[rgba(139,92,246,0.18)] border border-[rgba(139,92,246,0.4)] text-white"
                                                    : "bg-white/[0.03] border border-white/[0.08] text-white/70 hover:border-white/20"}`}
                                            >
                                                <Globe size={14} aria-hidden="true" /> {d.hostname}
                                                {d.kind === "own" && <span className="text-[10px] text-[#a78bfa]">seu</span>}
                                            </button>
                                        );
                                    })}
                                </div>
                            </div>
                        )}

                        {/* Seletor de origem */}
                        <div className="text-xs uppercase tracking-wide text-white/40 mb-3">
                            Onde este link será divulgado?
                        </div>
                        <div className="grid grid-cols-2 md:flex md:flex-wrap gap-2 mb-4">
                            {AD_ORIGINS.map((o) => {
                                const active = selectedId === o.id;
                                const base = "inline-flex items-center justify-center md:justify-start gap-2 w-full md:w-auto px-3 py-2 rounded-lg text-sm font-medium transition";
                                const cls = !o.ready
                                    ? `${base} opacity-40 cursor-not-allowed bg-white/[0.02] border border-white/[0.06] text-white/50`
                                    : active
                                        ? `${base} bg-[rgba(139,92,246,0.18)] border border-[rgba(139,92,246,0.4)] text-white`
                                        : `${base} bg-white/[0.03] border border-white/[0.08] text-white/70 hover:border-white/20`;
                                return (
                                    <button key={o.id} disabled={!o.ready} onClick={() => selectOrigin(o.id)} className={cls}>
                                        <BrandIcon brand={o.brand} size={15} /> {o.label}
                                        {!o.ready && <span className="text-[10px]">em breve</span>}
                                    </button>
                                );
                            })}
                        </div>

                        {/* Outras origens (orgânicas) — dropdown temático, sem label */}
                        <div className="mb-6">
                            <OrganicSelect
                                value={isOrganicSelected ? selectedId : ""}
                                onSelect={selectOrigin}
                            />
                        </div>

                        {ready ? (
                            <>
                                {/* Editar parâmetros avançados */}
                                <div className="rounded-xl border border-white/[0.08] bg-white/[0.02] mb-6">
                                    <button
                                        onClick={() => setAdvancedOpen((v) => !v)}
                                        className="w-full flex items-center justify-between px-4 py-3 text-sm font-semibold"
                                    >
                                        <span className="flex items-center gap-2">
                                            <SlidersHorizontal size={15} /> Editar parâmetros avançados
                                        </span>
                                        <ChevronDown size={16} className={`transition-transform ${advancedOpen ? "rotate-180" : ""}`} />
                                    </button>
                                    {advancedOpen && (
                                        <div className="px-4 pb-4 grid grid-cols-1 md:grid-cols-2 gap-4">
                                            {UTM_FIELDS.map((f) => (
                                                <div key={f.key}>
                                                    <div className="flex items-center justify-between mb-1">
                                                        <span className="text-sm font-semibold text-white">{f.label}</span>
                                                        <code className="text-[11px] text-white/35">{f.utm}</code>
                                                    </div>
                                                    <input
                                                        type="text"
                                                        value={params[f.key] || ""}
                                                        onChange={(e) => setParams((p) => ({ ...p, [f.key]: e.target.value }))}
                                                        className="w-full px-3 py-2 rounded-lg bg-black/30 border border-white/[0.08] text-sm text-white outline-none focus:border-[rgba(139,92,246,0.4)]"
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                {/* Links montados */}
                                <div className="space-y-4">
                                    <CopyRow
                                        label="Link completo"
                                        hint={`URL pronta com as UTMs de ${origin.label}.`}
                                        value={fullUrl}
                                        copyLabel={`Copiar link para ${origin.label}`}
                                        primary
                                    />
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-stretch">
                                        <CopyRow
                                            label="URL do site"
                                            hint="Endereço base do redirecionador, sem parâmetros."
                                            value={siteUrl}
                                            copyLabel="Copiar URL do site"
                                        />
                                        <CopyRow
                                            label="Parâmetros"
                                            hint={`UTMs brutas com as macros de ${origin.label}.`}
                                            value={paramString}
                                            copyLabel={`Copiar parâmetros de ${origin.label}`}
                                        />
                                    </div>
                                </div>
                            </>
                        ) : (
                            <div className="text-sm text-white/50 py-6 text-center">
                                {origin.label} ainda não está disponível.
                            </div>
                        )}

                        <div className="flex justify-end mt-6">
                            <button onClick={onClose} className="btn-secondary">Fechar</button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
